import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import React from "react";
import { AlertOccurrenceListItem } from "components/AlertsManagement/AlertInfo/AlertOccurrenceListItem";

export const AlertOccurrenceList = React.memo(function AlertOccurrenceList({
  alertOccurrences
}) {
  return (
    <List>
      {alertOccurrences.length > 0 ? (
        alertOccurrences.map(alertOccurrence => (
          <AlertOccurrenceListItem
            key={alertOccurrence.id}
            alertOccurrence={alertOccurrence}
          />
        ))
      ) : (
        <Typography>No previous alert occurrences</Typography>
      )}
    </List>
  );
});

AlertOccurrenceList.propTypes = {
  alertPeriodStartDate: PropTypes.string,
  alertOccurrences: PropTypes.array
};

const List = styled("div")`
  display: flex;
  flex-direction: column;
  padding: ${props => props.theme.spacing(2)};
  gap: ${props => props.theme.spacing(2)};
  background-color: #ecf7f1;
  border-radius: 3px;
`;
